import { useEffect, useState } from 'react';

import EmailIcon from 'icons/email.svg?react';
import { toast } from 'material-react-toastify';

import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';
import { TextField } from '@/components/shared/TextField/TextField';
import { useHubStore } from '@/lib/store/hubStore';

import { useUpdateUserName } from '../../hooks/useUpdateUserName';

interface EditNameModalProps {
  isPopupOpen: boolean;
  closePopup: () => void;
  userName: string;
}

const EditNameModal = ({ isPopupOpen, closePopup, userName }: EditNameModalProps) => {
  const user = useHubStore((state) => state.searchUserData);
  const [name, setName] = useState<string>(userName);
  const updateNameMutation = useUpdateUserName(user?.email || '');

  const handleChangeName = async () => {
    if (!user?.id) {
      toast.error('User ID is missing');
      return;
    }

    updateNameMutation.mutate(
      { userId: user.id, name },
      {
        onSuccess: () => {
          closePopup();
          toast.success(`User's name was successfully changed`);
        },
        onError: (error) => {
          closePopup();
          toast.error(error.message);
        },
      },
    );
  };

  useEffect(() => {
    setName(userName);
  }, [userName]);

  return (
    <Popup isOpen={isPopupOpen} handleClose={closePopup}>
      <div className="absolute top-[20px] left-[12px] rounded-lg bg-[#F2F2F2] p-2">
        <EmailIcon />
      </div>
      <div className="max-w-[340px] ml-12">
        <Text.Bigger className="mb-2" weight="bold">
          Name change request
        </Text.Bigger>
        <Text.Regular>Please enter the name you need to change in the field below:</Text.Regular>
        <TextField
          startIcon={<EmailIcon className="opacity-25" />}
          className="my-4"
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={updateNameMutation.isPending}
        />

        <div className="flex justify-center items-center gap-2">
          <Button
            label={updateNameMutation.isPending ? 'Updating...' : 'Change Name'}
            size="s"
            className="!w-44"
            onClick={handleChangeName}
            prefixIcon={<img alt={'check'} src={'/icons/check.svg'} />}
            disabled={updateNameMutation.isPending || name === userName}
          />
          <Button
            prefixIcon={<img alt={'close'} src={'/icons/close_outline.svg'} />}
            label="Cancel"
            variant="transparent"
            onClick={closePopup}
            className="!w-28"
            size="s"
            disabled={updateNameMutation.isPending}
          />
        </div>
      </div>
    </Popup>
  );
};

export default EditNameModal;
